import { render, staticRenderFns } from "./AppRegistry.vue?vue&type=template&id=27b34b6e"
import script from "./AppRegistry.vue?vue&type=script&lang=js"
export * from "./AppRegistry.vue?vue&type=script&lang=js"
import style0 from "./AppRegistry.vue?vue&type=style&index=0&id=27b34b6e&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports